import { Record, List } from 'immutable';

export class TrackDump extends Record({
  id:         '',
  kind:       '',
  label:      '',
  enabled:    false,
  muted:      false,
  readyState: '',
}, 'TrackDump') {
  constructor(track) {
    if (track) {
      const { id, kind, label, enabled, muted, readyState } = track;
      super({ id, kind, label, enabled, muted, readyState });
    } else {
      super();
    }
  }
}

export class MediaStreamDump extends Record({
  id: '',
  active: false,
  tracks: List(),
}) {
  constructor(stream) {
    if (stream) {
      const { id, active } = stream;
      super({
        id,
        active,
        tracks: List(stream.getTracks()).map(t => new TrackDump(t)),
      });
    } else {
      super();
    }
  }
}

// For now these are the same
export class SenderOrReceiverDump extends Record({
  track: null,
}, 'SenderOrReceiverDump') {
  constructor(receiver) {
    if (receiver && receiver.track) {
      super({ track: new TrackDump(receiver.track) });
    } else {
      super();
    }
  }
}

export class TransceiverDump extends Record({
  mid:              '',
  direction:        '',
  currentDirection: '',
  stopped:          false,
  sender:           null,
  receiver:         null,
}, 'TransceiverDump') {
  constructor(transceiver) {
    if (transceiver) {
      const { mid, direction, currentDirection, stopped, sender, receiver } = transceiver;
      super({
        mid, direction, currentDirection, stopped,
        sender:   sender && new SenderOrReceiverDump(sender),
        receiver: receiver && new SenderOrReceiverDump(receiver),
      });
    } else {
      super();
    }
  }
}

export default class ConnectionMediaDump extends Record({
  transceivers: List(),
  receivers:    List(),
  senders:      List(),
  localStreams: List(),
  remoteSteams: List(),
}, 'ConnectionMediaDump') {
  constructor(connection) {
    if (!connection) {
      super();
    } else if (connection.getTransceivers) {
      super({
        transceivers: List(connection.getTransceivers()).map(t => new TransceiverDump(t)),
      });
    } else if (connection.getReceivers && connection.getSenders) {
      super({
        receivers: List(connection.getReceivers()).map(r => new SenderOrReceiverDump(r)),
        senders:   List(connection.getSenders()).map(r => new SenderOrReceiverDump(r)),
      });
    } else {
      super({
        localStreams:  List(connection.getLocalStreams()).map(s => new MediaStreamDump(s)),
        remoteStreams: List(connection.getRemoteStreams()).map(s => new MediaStreamDump(s)),
      });
    }
  }
}
